import React, { useContext } from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { fontWeight } from "../../../../constant";
import LatestNewsContext from "../../../context/LatestNewsContext/LatestNewsContext";
import { Switch } from "@material-ui/core";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc } from "../../../utils";
import { UploadCloud } from "react-feather";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { delete_Multi_Image_Permanent } from "../apis/SliderApi/SliderApi";
import { Zoom, toast } from "react-toastify";
import CommonColor from "../../../common/CommonColor";
import CustomStyle from "../../../common/CustomStyle";

const LatestNewThemeOne = (props) => {
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const {
    isEdit,
    settingFormData,
    setSettingFormData,
    backImageToggle,
    setbackImageToggle,
    boxSection,
    setBoxSection,
    isBackgroundColor,
    setIsBackgroundColor,
  } = useContext(LatestNewsContext);
  const { imageUpload } = props;

  /**
   * input value change
   * @param {event} e
   */

  const handleChangeLatestNewsSection = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".latest-news-section"]: {
          ...prev[".latest-news-section"],
          [name]: value,
        },
      };
    });
  };

  const handleChangeLatestNewsLabel = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".latest-news-section .news-label"]: {
          ...prev[".latest-news-section .news-label"],
          [name]: value,
        },
      };
    });
  };

  const handleChangeLatestMarqueeA = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".latest-news-section marquee a"]: {
          ...prev[".latest-news-section marquee a"],
          [name]: value,
        },
      };
    });
  };

  const handleChangeLatestMarquee = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".latest-news-section marquee"]: {
          ...prev[".latest-news-section marquee"],
          [name]: value,
        },
      };
    });
  };

  const handleChangeLatestNewsSectionBgImage = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".latest-news-section.bg-image::before"]: {
          ...prev[".latest-news-section.bg-image::before"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeCustomStyle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleReset = () => {
    setSettingFormData({
      ".latest-news-section": {
        padding: "30px 0",
        "background-color": { r: 33, g: 37, b: 41, a: 100 },
      },
      ".latest-news-section.bg-image": {
        "background-image": "",
      },
      ".latest-news-section.bg-image::before": {
        "background-color": "",
        // "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
      },
      ".latest-news-section .news-label": {
        color: { r: 255, g: 255, b: 255, a: 100 },
        "font-size": "20px",
        "font-weight": 500,
        "margin-right": "15px",
      },
      ".latest-news-section marquee": {
        color: { r: 255, g: 255, b: 255, a: 100 },
      },
      ".latest-news-section marquee a": {
        color: { r: 255, g: 73, b: 124, a: 100 },
      },
      custom: "",
      latestNewsId: "",
    });
    setbackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };
  /**
   * delete image permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: settingFormData?.[".latest-news-section.bg-image"]?.[
            "background-image"
          ]
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setSettingFormData({
            ...settingFormData,
            ".latest-news-section.bg-image": { "background-image": "" },
          });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };
  /**
   * image reupload
   */
  const reupload = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };
  return (
    <>
      <Row className="mt-4">
        <h4 className="mb-3">Make change in Main section</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Padding (default : 100)"}
          </Label>
          <Input
            className="form-control"
            name="padding"
            type="text"
            placeholder="padding"
            value={settingFormData?.[".latest-news-section"]?.["padding"]
              ?.split(" ")[0]
              ?.replace(/px/g, "")}
            onChange={(e) => handleChangeLatestNewsSection(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <div className="d-flex align-items-center">
            <Label htmlFor="validationCustom03">
              {isBackgroundColor
                ? "Add Background Color"
                : "Remove Background Color"}
            </Label>
            <Switch
              checked={isBackgroundColor}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(e) => {
                setIsBackgroundColor(e.target.checked);
                setSettingFormData((prev) => {
                  if (e.target.checked) {
                    if (boxSection) {
                      return {
                        ...prev,
                        [".latest-news-section"]: {
                          "background-color": "#212529",
                          padding:
                            settingFormData?.[".latest-news-section"]?.[
                              "padding"
                            ],
                          width: settingFormData?.[".latest-news-section"]?.[
                            "width"
                          ]?.replace("rem)", ""),
                          margin: settingFormData?.[".latest-news-section"]?.[
                            "margin"
                          ]
                            ?.split(" ")[0]
                            ?.replace(/px/g, ""),
                          "border-radius": settingFormData?.[
                            ".latest-news-section"
                          ]?.["border-radius"]?.replace(/rem/g, ""),
                        },
                      };
                    } else {
                      return {
                        ...prev,
                        [".latest-news-section"]: {
                          "background-color": "#212529",
                          padding:
                            settingFormData?.[".latest-news-section"]?.[
                              "padding"
                            ],
                        },
                      };
                    }
                  } else {
                    if (boxSection) {
                      return {
                        ...prev,
                        [".latest-news-section"]: {
                          padding:
                            settingFormData?.[".latest-news-section"]?.[
                              "padding"
                            ],
                          width: settingFormData?.[".latest-news-section"]?.[
                            "width"
                          ]?.replace("rem)", ""),
                          margin: settingFormData?.[".latest-news-section"]?.[
                            "margin"
                          ]
                            ?.split(" ")[0]
                            ?.replace(/px/g, ""),
                          "border-radius": settingFormData?.[
                            ".latest-news-section"
                          ]?.["border-radius"]?.replace(/rem/g, ""),
                        },
                      };
                    } else {
                      return {
                        ...prev,
                        [".latest-news-section"]: {
                          padding:
                            settingFormData?.[".latest-news-section"]?.[
                              "padding"
                            ],
                        },
                      };
                    }
                  }
                });
              }}
            />
          </div>
          {isBackgroundColor && (
            <CommonColor
              color={
                settingFormData?.[".latest-news-section"]?.["background-color"]
              }
              setSettingFormData={setSettingFormData}
              className={".latest-news-section"}
              classProperty={"background-color"}
              label={"Select Background Color"}
            />
          )}
        </Col>
        <p>{"Box Section : convert your section to Box section"}</p>
        <div>
          <Switch
            checked={boxSection}
            inputProps={{ "aria-label": "controlled" }}
            onChange={(e) => {
              setBoxSection(e.target.checked);
              setSettingFormData((prev) => {
                return {
                  ...prev,
                  ".latest-news-section": {
                    padding:
                      settingFormData?.[".latest-news-section"]?.["padding"],
                    "background-color":
                      settingFormData?.[".latest-news-section"]?.[
                        "background-color"
                      ],
                    width: e.target.checked ? "10" : "",
                    margin: e.target.checked ? "0" : "",
                    "border-radius": e.target.checked ? "3" : "",
                  },
                };
              });
            }}
          />
        </div>
        {boxSection && (
          <>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Width (Default : 10)"}
              </Label>
              <Input
                className="form-control"
                name="width"
                type="number"
                placeholder="width"
                value={settingFormData?.[".latest-news-section"]?.[
                  "width"
                ]?.replace("rem)", "")}
                onChange={(e) => handleChangeLatestNewsSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Margin (Default : 0)"}
              </Label>
              <Input
                className="form-control"
                name="margin"
                type="number"
                placeholder="margin"
                value={settingFormData?.[".latest-news-section"]?.["margin"]
                  ?.split(" ")[0]
                  ?.replace(/px/g, "")}
                onChange={(e) => handleChangeLatestNewsSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Border Radius (Default : 3)"}
              </Label>
              <Input
                className="form-control"
                name="border-radius"
                type="number"
                placeholder="Border Radius"
                value={settingFormData?.[".latest-news-section"]?.[
                  "border-radius"
                ]?.replace(/rem/g, "")}
                onChange={(e) => handleChangeLatestNewsSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
          </>
        )}
      </Row>
      <hr />
      <Row className="mt-4">
        <Col md="12 mb-3">
          <h4 className="mb-3">Add Background Image in section</h4>

          <p>do you want to upload Background image</p>
          <Switch
            checked={backImageToggle}
            inputProps={{ "aria-label": "controlled" }}
            onChange={(e) => {
              setbackImageToggle(e.target.checked);
              setSettingFormData((prev) => {
                if (e.target.checked) {
                  return {
                    ...prev,
                    image: "",
                    ".latest-news-section.bg-image": {},
                    ".latest-news-section.bg-image::before": {
                      "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
                    },
                  };
                } else {
                  return {
                    ...prev,
                    image: "",
                    ".latest-news-section.bg-image": {},
                    ".latest-news-section.bg-image::before": {},
                  };
                }
              });
            }}
          />
          {backImageToggle && (
            <>
              {" "}
              <Col md="6 mb-3">
                <Dividers divide="IMAGE" />
                <p className="mb-4">
                  File type required JPG, PNG (1905px X 84px)
                </p>
              </Col>
              <Row>
                <Col md="4 mb-3">
                  <div
                    className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    {!settingFormData?.[".latest-news-section.bg-image"]?.[
                      "background-image"
                    ] && (
                      <span
                        onClick={() =>
                          OpenModalCommonFunc(
                            Cases.PRODUCT_UPLOAD,
                            setAllPopupState
                          )
                        }
                      >
                        <UploadCloud />
                      </span>
                    )}

                    {settingFormData?.[".latest-news-section.bg-image"]?.[
                      "background-image"
                    ] && (
                      <img
                        src={
                          settingFormData?.[".latest-news-section.bg-image"]?.[
                            "background-image"
                          ] || ""
                        }
                        alt=""
                        style={{
                          width: "85%",
                          height: "90px",
                          objectFit: "contain",
                          position: "absolute",
                        }}
                        onClick={() => deleteImagePermanent()}
                      />
                    )}
                    {settingFormData?.[".latest-news-section.bg-image"]?.[
                      "background-image"
                    ] && (
                      <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="close"
                        style={{
                          color: "red",
                          position: "absolute",
                          top: "-22px",
                          left: "1px",
                        }}
                        onClick={() => deleteImagePermanent()}
                      >
                        <Close
                          style={{
                            fontSize: "25px",
                            fontWeight: "bold",
                          }}
                        />
                      </IconButton>
                    )}
                  </div>
                </Col>
                <Col md="6 mb-3">
                  <h4 className="mb-3">Add Background color in section</h4>

                  <Col md="6 mb-3">
                    <CommonColor
                      color={
                        settingFormData?.[
                          ".latest-news-section.bg-image::before"
                        ]?.["background-color"]
                      }
                      setSettingFormData={setSettingFormData}
                      className={".latest-news-section.bg-image::before"}
                      classProperty={"background-color"}
                      label={"Select Background Color"}
                    />
                  </Col>
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>

      <hr />
      <Row className="mt-2">
        <h4 className="mb-3">Make change in latest news section label</h4>
        <Col md="4 mb-3">
          <CommonColor
            color={
              settingFormData?.[".latest-news-section .news-label"]?.["color"]
            }
            setSettingFormData={setSettingFormData}
            className={".latest-news-section .news-label"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Size (Default : 20)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="text"
            placeholder="Font Size"
            value={settingFormData?.[".latest-news-section .news-label"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeLatestNewsLabel(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Weight (Default : 500)"}
          </Label>
          <select
            name="font-weight"
            id="font-weight"
            className="form-select"
            value={
              settingFormData?.[".latest-news-section .news-label"]?.[
                "font-weight"
              ]
            }
            onChange={(e) => handleChangeLatestNewsLabel(e)}
            style={{ borderRadius: "0", color: "black" }}
          >
            <option value="">--select--</option>
            {fontWeight.map((elem) => {
              return (
                <option value={elem["font-weight"]}>
                  {elem["font-weight"]}
                </option>
              );
            })}
          </select>
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Right (Default : 15)"}
          </Label>
          <Input
            className="form-control"
            name="margin-right"
            type="text"
            placeholder="Font Size"
            value={settingFormData?.[".latest-news-section .news-label"]?.[
              "margin-right"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeLatestNewsLabel(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-2">
        <h4 className="mb-3">Change latest news section | marquee color</h4>
        <Col md="2 mb-3">
          <CommonColor
            color={settingFormData?.[".latest-news-section marquee"]?.["color"]}
            setSettingFormData={setSettingFormData}
            className={".latest-news-section marquee"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-2">
        <h4 className="mb-3">
          Change latest news section | marquee text color
        </h4>
        <Col md="2 mb-3">
          <CommonColor
            color={
              settingFormData?.[".latest-news-section marquee a"]?.["color"]
            }
            setSettingFormData={setSettingFormData}
            className={".latest-news-section marquee a"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
      </Row>
      <CustomStyle
        handleChange={handleChangeCustomStyle}
        value={settingFormData?.custom}
      />

      <ProductImageUploadPopup
        allPopupState={allPopupState}
        setAllPopupState={setAllPopupState}
        crop={crop}
        setCrop={setCrop}
        completedCrop={completedCrop}
        setCompletedCrop={setCompletedCrop}
        scale={scale}
        rotate={rotate}
        image={settingFormData?.image}
        setImage={setSettingFormData}
        imageUpload={imageUpload}
        isEdit={isEdit}
        reupload={reupload}
        // aspect={22.68 / 1}
      />
    </>
  );
};

export default LatestNewThemeOne;
